var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M384 472H48V40h224l112 112v320z",
    fill: "#ffffff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 424H96V8h224l112 112v304z",
    fill: "#ffffff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 120h112L320 8v112z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 360h-16a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16zM384 360H192a8 8 0 0 1 0-16h192a8 8 0 0 1 0 16zM160 312h-16a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16zM384 312H192a8 8 0 0 1 0-16h192a8 8 0 0 1 0 16zM160 264h-16a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16zM384 264H192a8 8 0 0 1 0-16h192a8 8 0 0 1 0 16zM160 216h-16a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16zM384 216H192a8 8 0 0 1 0-16h192a8 8 0 0 1 0 16zM160 168h-16a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16zM384 168H192a8 8 0 0 1 0-16h192a8 8 0 0 1 0 16zM144 80h48v48h-48V80z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 360h16a8 8 0 0 0 0-16h-16a8 8 0 0 0 0 16zM384 344H192a8 8 0 0 0 0 16h192a8 8 0 0 0 0-16zM144 312h16a8 8 0 0 0 0-16h-16a8 8 0 0 0 0 16zM384 296H192a8 8 0 0 0 0 16h192a8 8 0 0 0 0-16zM144 264h16a8 8 0 0 0 0-16h-16a8 8 0 0 0 0 16zM384 248H192a8 8 0 0 0 0 16h192a8 8 0 0 0 0-16zM144 216h16a8 8 0 0 0 0-16h-16a8 8 0 0 0 0 16zM384 200H192a8 8 0 0 0 0 16h192a8 8 0 0 0 0-16zM144 168h16a8 8 0 0 0 0-16h-16a8 8 0 0 0 0 16zM184 160a8 8 0 0 0 8 8h192a8 8 0 0 0 0-16H192a8 8 0 0 0-8 8z",
    fill: "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 480h336a8 8 0 0 0 8-8v-40h40a8 8 0 0 0 8-8V120c0-.176-.088-.328-.104-.504a7.557 7.557 0 0 0-.408-2.056c-.088-.256-.152-.504-.264-.752a7.998 7.998 0 0 0-1.6-2.344l-112-112a7.998 7.998 0 0 0-2.344-1.6c-.248-.112-.496-.176-.744-.264a7.967 7.967 0 0 0-2.072-.416C320.328.088 320.176 0 320 0H96a8 8 0 0 0-8 8v24H48a8 8 0 0 0-8 8v432a8 8 0 0 0 8 8zm364.688-368H328V27.312L412.688 112zM104 16h208v104a8 8 0 0 0 8 8h104v288H104V16zM56 48h32v376a8 8 0 0 0 8 8h280v32H56V48z",
    fill: "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 136h48a8 8 0 0 0 8-8V80a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zm8-48h32v32h-32V88z",
    fill: "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.1c4b666c8aea167bf1c3f5cb4addf6ab.svg";
export { ForwardRef as ReactComponent };